import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpErrorService } from '@web/common';
import { AlertsComponent, AlertsService } from '@web/shared/ui';
import { Guid, once } from '@web/utils';
import { AdminBrandBannerDetailsForm } from '../../models/admin-brand-banner-details-form';
import { AdminBrandBannerDataSourceService } from '../../services/admin-brand-banner-data-source.service';
import { AdminBrandBannerDetailsFormComponent } from '../admin-brand-banner-details-form/admin-brand-banner-details-form.component';

@Component({
  selector: 'app-admin-brand-banner-create',
  imports: [AdminBrandBannerDetailsFormComponent, AlertsComponent],
  templateUrl: './admin-brand-banner-create.component.html',
  styleUrl: './admin-brand-banner-create.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class AdminBrandBannerCreateComponent {
  private readonly bannerDataSource = inject(AdminBrandBannerDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public readonly brandId = input.required<Guid>();
  public readonly submitSuccessEvent = output<void>();

  public handleSubmitClickEvent(data: AdminBrandBannerDetailsForm): void {
    this.bannerDataSource
      .createByFormData({ brandId: this.brandId(), data })
      .pipe(once())
      .subscribe({
        next: () => this.submitSuccessEvent.emit(),
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    const messages = this.httpError.extract(response).messages();

    this.alerts.showMultiple((builder) =>
      messages.map((message) => builder.buildFailure(message)),
    );
  }
}
